import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';

import { MarsDebatesService } from './mars-debates/mars-debates.service';
import { MarsQuestionsService } from './mars-questions/services/mars-questions.service';

import { MarsDebateComponent } from './mars-debates/mars-debate/mars-debate.component';
import { MarsDebatesComponent } from './mars-debates/mars-debates.component';

import { MarsMessagesComponent } from './mars-messages/mars-messages.component';

import { MarsQuestionEditorComponent } from './mars-questions/mars-question-editor/mars-question-editor.component';
import { MarsQuestionsCreateComponent } from './mars-questions/mars-questions-create/mars-questions-create.component';
import { MarsQuestionsComponent } from './mars-questions/mars-questions.component';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [
    MarsDebateComponent,
    MarsDebatesComponent,
    MarsMessagesComponent,
    MarsQuestionEditorComponent,
    MarsQuestionsCreateComponent,
    MarsQuestionsComponent
  ],
  exports: [MarsDebatesComponent, MarsMessagesComponent, MarsQuestionsComponent],
  providers: [MarsDebatesService, MarsQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarsTutorizationModule {}
